import moment from "moment"

/**
 * Define or update the "es" moment locale and set it as the global locale.
 * moment.locale(name, config) redefines the locale on every call and logs a deprecation
 * warning once it already exists, so later calls go through moment.updateLocale, which
 * merges the config the same way without the warning.
 *
 * @param {Object} config Locale config (months, monthsShort, weekdays, ...)
 */
export const setSpanishLocale = (config) => {
  if (moment.locales().includes("es")) {
    moment.updateLocale("es", config)
  } else {
    moment.locale("es", config)
  }
}
